import * as angular from 'angular';

class WizardDiscardPopup implements ng.IController {
	static $inject = ['$scope', '$translate'];
	modalInstance: ng.ui.bootstrap.IModalServiceInstance = <any>this;
    form: ng.IFormController & { stickerID: ng.INgModelController};


	constructor(
		public $scope: ng.IScope,
		protected $translate: angular.translate.ITranslateService
	) { }

	close = () => {
		this.modalInstance.close({ $value: 'close' });
	}

	delete = () => {
		this.modalInstance.close({ $value: 'ok'});
    }
}

angular.module('naut').component('wizardDiscardPopup', {
	template: require('./wizard-discard-popup.component.html'),
	controller: WizardDiscardPopup,
    controllerAs: 'ctrl',
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	}
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/wizard/discard-popup/wizard-discard-popup.component.ts